module.exports = __webpack_public_path__ + "static/media/223-150.7ffcce0a.webp";